import type { ProgramId } from './programs'

export type JobCampaign = {
  id: string
  title: string
  link: string
  active: boolean
  exclusive: boolean
  exclusiveTitle?: string
  programId?: ProgramId
  eventId?: string
}

export const jobCampaigns: JobCampaign[] = [
  {
    id: 'ja-regular',
    title: 'All jobs',
    link: '#',
    active: true,
    exclusive: false
  },
  {
    id: 'ja-kydp-2024',
    title: 'KYouth jobs',
    link: '#',
    active: true,
    exclusive: true,
    exclusiveTitle: 'KYouth Exclusive',
    programId: 'kydp-2024'
  },
  {
    id: 'ja-kydp-2024-b',
    title: 'KYouth Track B jobs',
    link: '#',
    active: true,
    exclusive: true,
    exclusiveTitle: 'KYouth (B) Exclusive',
    programId: 'kydp-2024-b'
  },
  {
    id: 'ja-kl-cf-2024',
    title: 'KL Career Fair jobs',
    link: '#',
    active: true,
    exclusive: false,
    eventId: 'kl-cf-2024'
  }
]
